import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import { Link } from "react-router-dom";

/*
 * Testimonials — placeholder page to be filled with real stories as
 * ZelTechnology helps people. Real names require written permission
 * (see AGENTS.md Section 26: Privacy and User Data).
 */

const placeholderQuotes = [
  {
    text: "This space is waiting for the first story of someone we've helped.",
    name: "Story #1",
    detail: "Your testimonial could be here",
  },
  {
    text: "Every free fix, every scam stopped, every senior who didn't lose their savings — that's a story worth telling.",
    name: "Story #2",
    detail: "Your testimonial could be here",
  },
  {
    text: "We're a young nonprofit. The best testimonials haven't been written yet — help us write them.",
    name: "Story #3",
    detail: "Your testimonial could be here",
  },
];

const Testimonials = () => {
  useDocTitle("ZelT | Stories");

  return (
    <div>
      <NavBar />
      <div className="mt-8 w-full bg-white py-12 lg:py-20">
        <div className="mx-4 max-w-4xl mx-auto">
          <h1
            className="text-4xl font-extrabold text-blue-900 text-center mb-4"
            data-aos="zoom-in"
          >
            Stories From Our Community
          </h1>
          <p className="text-gray-600 text-center mb-10" data-aos="fade-up">
            Real help, real people. We only publish testimonials with written
            permission — so this page grows one honest story at a time.
          </p>

          <div className="grid gap-6 md:grid-cols-3" data-aos="fade-up">
            {placeholderQuotes.map((t, i) => (
              <div
                key={i}
                className="bg-gray-50 rounded-2xl p-6 border-t-4 shadow-md"
                style={{ borderTopColor: ["#12bfbe", "#9198e5", "#1e3a8a"][i] }}
              >
                <p className="text-gray-600 italic leading-relaxed">"{t.text}"</p>
                <p className="mt-4 font-bold text-blue-900">{t.name}</p>
                <p className="text-xs text-gray-400">{t.detail}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center" data-aos="fade-up">
            <p className="text-gray-600 mb-4">
              Been helped by ZelTechnology? We'd love to hear your story.
            </p>
            <Link
              to="/contact"
              className="inline-block px-6 py-3 rounded-xl bg-blue-900 text-white font-bold hover:bg-blue-800 transition"
            >
              Share Your Story
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Testimonials;
